export const ALLOWED_COURSES_TYPES = ['course', 'pack'] as const;
